import DialogContent from "@mui/material/DialogContent";
import React, { useCallback, useEffect } from "react";
import { useDialog } from "../../../old/beheer/views/Upsell/modernTS/JUI/Dialogs";
import {
  Box,
  Button,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { ApiPiggyReward, useUpdateOrCreatePiggyRewardMutation } from "./api/piggyRewardsApi";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import PickVoucherDefinition from "./PickVoucherDefinition";
import { useAppSelector } from "../../../old/beheer/store";
import { selectSalesAreaId } from "../../SalesAreas/selectors/selectSalesAreaId";

export default function useConfigureRewardDialog() {
  const { createDialog, closeDialog } = useDialog();
  return useCallback(
    (apiPiggyReward: ApiPiggyReward) => {
      return new Promise((resolve) => {
        createDialog({
          name: "configure-reward-dialog",
          maxWidth: "lg",
          children: (
            <ConfigureRewardDialog
              apiPiggyReward={apiPiggyReward}
              onOk={() => {
                resolve("");
                closeDialog("configure-reward-dialog");
              }}
            />
          ),
        });
      });
    },
    [closeDialog, createDialog]
  );
}

function ConfigureRewardDialog({ apiPiggyReward, onOk }: { apiPiggyReward: ApiPiggyReward; onOk: () => void }) {
  const salesAreaId = useAppSelector(selectSalesAreaId);
  const useFormMethods = useForm<{ rewardable_type: string | null; rewardable_id: number | null }>({
    defaultValues: {
      rewardable_type: apiPiggyReward.jamezzPiggyReward?.rewardable_type ?? "",
      rewardable_id: apiPiggyReward.jamezzPiggyReward?.rewardable_id ?? undefined,
    },
  });
  const { control, register, handleSubmit, setValue } = useFormMethods;

  const [updateOrCreate] = useUpdateOrCreatePiggyRewardMutation();

  const onSubmit = useCallback(
    (data: { rewardable_type: string | null; rewardable_id: number | null }) => {
      updateOrCreate({
        ...data,
        piggy_id: apiPiggyReward.id,
        piggy_uuid: apiPiggyReward.uuid,
        vestiging_id: salesAreaId ?? 0,
      }).then((response) => {
        if (!response.error) {
          onOk();
        }
      });
    },
    [apiPiggyReward.id, apiPiggyReward.uuid, onOk, salesAreaId, updateOrCreate]
  );

  const rewardableType = useWatch({ name: "rewardable_type", control });
  const rewardableId = useWatch({ name: "rewardable_id", control });

  useEffect(() => {
    return () => {
      setValue("rewardable_id", null);
    };
  }, [rewardableType, setValue]);

  return (
    <FormProvider {...useFormMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box>
          <DialogTitle>Configure reward</DialogTitle>
          <Divider sx={{ mb: 2 }} />
          {rewardableType}
          {rewardableId}
          <DialogContent>
            <Stack gap={2}>
              <FormControl fullWidth={true}>
                <InputLabel>Reward type</InputLabel>
                <Select {...register("rewardable_type")} label={"Reward type"} variant={"outlined"}>
                  <MenuItem value={""}>None</MenuItem>
                  <MenuItem value={"App\\voucherdef"}>Jamezz Voucher definition</MenuItem>
                </Select>
              </FormControl>

              {rewardableType === "App\\voucherdef" ? <PickVoucherDefinition /> : null}
            </Stack>
          </DialogContent>
          <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
            <DialogActions sx={{ display: "flex", justifyContent: "space-between", gap: 6 }}>
              <Button onClick={onOk}>Cancel</Button>

              <Button color={"success"} type={"submit"} variant={"contained"}>
                Save
              </Button>
            </DialogActions>
          </Box>
        </Box>
      </form>
    </FormProvider>
  );
}
